export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '51吃瓜每日大赛',
  url: 'http://dingzhishi.cn/',
  description: '51吃瓜每日大赛作为吃瓜爆料核心站点，提供51吃瓜网今日吃瓜资源、51吃瓜黑料网及51吃瓜入口，每日不间断追踪娱乐圈网红内幕、明星翻车现场，全部内容免费浏览。',
  slogan: '全网热搜爆料，吃瓜一线直击',
  foundingDate: '2023',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    email: 'hello@dingzhishi.cn',
  },
  sameAs: ['http://dingzhishi.cn/'],
};

export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '51吃瓜每日大赛',
  url: 'http://dingzhishi.cn/',
  description: '51吃瓜每日大赛作为吃瓜爆料核心站点，每日不间断追踪娱乐圈网红内幕、明星翻车现场。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://dingzhishi.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export function buildBreadcrumbSchema(items: { name: string; url: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function buildArticleSchema(article: {
  title: string;
  description: string;
  imageUrl: string;
  datePublished: string;
  dateModified: string;
  url: string;
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.description,
    image: article.imageUrl,
    datePublished: article.datePublished,
    dateModified: article.dateModified,
    url: article.url,
    author: {
      '@type': 'Organization',
      name: '51吃瓜每日大赛',
    },
    publisher: {
      '@type': 'Organization',
      name: '51吃瓜每日大赛',
    },
  };
}

export function buildWebPageSchema(page: {
  title: string;
  description: string;
  url: string;
  dateModified?: string;
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: page.title,
    description: page.description,
    url: page.url,
    ...(page.dateModified ? { dateModified: page.dateModified } : {}),
  };
}

export function buildFAQSchema(faqs: { question: string; answer: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}